import Vue from "vue";
import VueRouter from "vue-router";
import api from "./api/client";

Vue.use(VueRouter);

const routes = [
  { path: "/login", name: "login", component: () => import("./views/Login.vue") },
  {
    path: "/",
    component: () => import("./views/Layout.vue"),
    children: [
      { path: "", redirect: { name: "users" } },
      { path: "users", name: "users", component: () => import("./views/Users.vue") },
      { path: "orders", name: "orders", component: () => import("./views/Orders.vue") },
      { path: "entitlements", name: "entitlements", component: () => import("./views/Entitlements.vue") },
      { path: "stats", name: "stats", component: () => import("./views/Stats.vue") },
      { path: "logs", name: "logs", component: () => import("./views/Logs.vue") },
      { path: "support", name: "support", component: () => import("./views/Support.vue") },
      { path: "share-cards", name: "share-cards", component: () => import("./views/ShareCards.vue") },
      { path: "growth-copilot", name: "growth-copilot", component: () => import("./views/GrowthCopilot.vue") },
      { path: "growth-drafts", name: "growth-drafts", component: () => import("./views/GrowthDrafts.vue") },
      { path: "plans", name: "plans", component: () => import("./views/Plans.vue") },
      { path: "channels", name: "channels", component: () => import("./views/Channels.vue") },
      { path: "settings", name: "settings", component: () => import("./views/Settings.vue") },
      { path: "members", name: "members", component: () => import("./views/Members.vue"), meta: { superOnly: true } },
    ],
  },
];

const router = new VueRouter({ mode: "hash", routes });

// 路由守卫：未登录跳登录页；已登录但访问登录页则进入首页
router.beforeEach(async (to, from, next) => {
  const token = api.getToken();
  if (to.name === "login") {
    if (token) return next({ name: "users" });
    return next();
  }
  if (!token) return next({ name: "login" });
  // 已登录：校验角色为 admin / superadmin（后端另有 require_admin|require_superadmin 兜底）
  try {
    const me = await api.me();
    if (me.role !== "admin" && me.role !== "superadmin") {
      api.setToken(null);
      return next({ name: "login", query: { denied: "1" } });
    }
    // 「系统成员管理」仅超管可见：非超管访问直接挡回账户管理
    if (to.meta && to.meta.superOnly && me.role !== "superadmin") {
      return next({ name: "users" });
    }
    next();
  } catch (e) {
    api.setToken(null);
    next({ name: "login" });
  }
});

export default router;
